// 권위: docs/ARCH_DASHBOARD.md §4.5 화면 5 Live Monitor.
// 좌측 이벤트 스트림의 색상 분류 / 스트림 최대 보관 수 / 일시정지 등 화면별 상수를 모은다.

import type { EventListItem } from '../../api/types';

export type StreamColor = 'green' | 'red' | 'yellow' | 'blue' | 'gray';

export const STREAM_MAX = 100;

/**
 * 이벤트 → 스트림 색상 규약 (§4.5 좌측 패널).
 * - GREEN: 매수 신호 / 체결 — `TRADING.ORDER.FILLED` / `TRADING.SIGNAL.BUY`
 * - RED  : 손절 / 매도    — `TRADING.ORDER.STOP_LOSS` / `TRADING.ORDER.SELL`
 * - YELLOW: 경고 / LLM WARN (severity=WARN)
 * - BLUE : GovernanceContext 배포 / LLM Gate 오버라이드 — `GOVERNANCE.CONTEXT.PUBLISHED`, `LLM.GATE_A.OVERRIDE_APPLIED`
 * - GRAY : 그 외 일반 INFO
 */
export function classifyStreamColor(ev: EventListItem): StreamColor {
  const code = ev.eventCode.toUpperCase();
  if (ev.severity === 'FATAL' || ev.severity === 'ERROR') return 'red';
  if (ev.severity === 'WARN') return 'yellow';
  if (code.includes('ORDER.FILLED') || code.includes('SIGNAL.BUY')) return 'green';
  if (code.includes('STOP_LOSS') || code.includes('ORDER.SELL') || code.includes('ORDER.CANCELED')) return 'red';
  if (
    code === 'GOVERNANCE.CONTEXT.PUBLISHED' ||
    code.startsWith('LLM.GATE_A.OVERRIDE') ||
    code.startsWith('LLM.GATE_')
  ) return 'blue';
  return 'gray';
}

/** `OBS.ALERT.SENT` 계열 이벤트만 고르기. (우측 패널 — Alert 이력) */
export function isAlertSent(ev: EventListItem): boolean {
  return ev.eventCode.toUpperCase().startsWith('OBS.ALERT.SENT');
}
